import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function InvoicelineContentReducer(state = initialState.invoicelineContent, action: any) {
  switch (action.type) {
    case types.SAVE_INVOICELINECONTENT_SUCCESS:
      return action.invoicelineContent;
    default:
      return state;
  }
}
